import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';
import { defineMessages, useIntl } from '@atlas/text';

export const messages = defineMessages({
    plusThick: { id: 'lblIconPlusThick', defaultMessage: 'Add' },
});

const PlusThickIcon = React.memo(function PlusThickIcon(props: TPlusThickIconProps): React.ReactElement {
    const intl = useIntl();

    return (
        <IconBase aria-label={intl.formatMessage(messages.plusThick)} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 15.5C10 15.7761 10.2239 16 10.5 16H11.5C11.7761 16 12 15.7761 12 15.5V12H15.5C15.7761 12 16 11.7761 16 11.5V10.5C16 10.2239 15.7761 10 15.5 10H12V6.5C12 6.22386 11.7761 6 11.5 6H10.5C10.2239 6 10 6.22386 10 6.5L10 10H6.5C6.22386 10 6 10.2239 6 10.5V11.5C6 11.7761 6.22386 12 6.5 12H10L10 15.5Z"
            />
        </IconBase>
    );
});

export default PlusThickIcon;

// #region Types

export type TPlusThickIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <PlusThickIcon /> : { ...IconBaseExample, render: PlusThickIcon };

// #endregion
